import { render, staticRenderFns } from "./LogoConfirmed.vue?vue&type=template&id=8f0d5eb4&scoped=true&"
var script = {}
import style0 from "./LogoConfirmed.vue?vue&type=style&index=0&id=8f0d5eb4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0d5eb4",
  null
  
)

export default component.exports